'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconSynchronizeArrowClock = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12.965 6a1 1 0 0 0-1 1v5.5a1 1 0 0 0 1 1h5a1 1 0 1 0 0-2h-3.75a.25.25 0 0 1-.25-.25V7a1 1 0 0 0-1-1z' }),
    _react2.default.createElement('path', { d: 'M12.567 1.258c-4.4.175-8.255 3-9.749 7.142a.25.25 0 0 1-.271.163L.858 8.309a.5.5 0 0 0-.506.743l2.679 4.7a.5.5 0 0 0 .786.107l3.77-3.746a.5.5 0 0 0-.279-.85l-1.715-.256a.25.25 0 0 1-.192-.35 8.259 8.259 0 1 1 7.866 11.59 1.25 1.25 0 1 0 .045 2.5h.047c5.935-.182 10.598-5.14 10.416-11.076-.182-5.934-5.14-10.598-11.075-10.416l-.133.005z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M13 12.998a.5.5 0 0 1-.5-.5v-5.5a.5.5 0 0 1 1 0v5H18a.5.5 0 0 1 0 1h-5z' }),
    _react2.default.createElement('path', { d: 'M13 22a.5.5 0 0 1 0-1c4.963 0 9-4.037 9-9s-4.037-9-9-9-9 4.037-9 9v.161l2.624-2.999a.5.5 0 0 1 .752.659l-3.5 4a.502.502 0 0 1-.376.173.26.26 0 0 1-.047-.005l-.029-.005a.518.518 0 0 1-.161-.054c-.01-.005-.03-.019-.039-.025a.473.473 0 0 1-.105-.095.269.269 0 0 1-.035-.042l-3-4.5c-.074-.11-.101-.243-.074-.374a.495.495 0 0 1 .489-.402c.168 0 .323.083.416.223L3 11.843C3.085 6.401 7.538 2 13 2c5.514 0 10 4.486 10 10s-4.486 10-10 10z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M13.5 22.75a.75.75 0 0 1 0-1.5c4.963 0 9-4.037 9-9s-4.037-9-9-9c-4.545 0-8.359 3.445-8.925 7.861L6.22 9.467a.744.744 0 0 1 1.06 0c.142.141.22.33.22.53s-.078.389-.22.53l-2.986 2.986a.733.733 0 0 1-.544.237.75.75 0 0 1-.56-.253l-2.97-2.97a.743.743 0 0 1-.22-.53c0-.2.078-.389.22-.53a.743.743 0 0 1 .53-.22c.2 0 .389.078.53.22l1.771 1.771C3.566 5.933 8.085 1.75 13.5 1.75c5.79 0 10.5 4.71 10.5 10.5s-4.71 10.5-10.5 10.5z' }),
    _react2.default.createElement('path', { d: 'M12.75 13.747a.75.75 0 0 1-.75-.75v-6.75a.75.75 0 0 1 1.5 0v6H18a.75.75 0 0 1 0 1.5h-5.25z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconSynchronizeArrowClock.displayName = 'IconSynchronizeArrowClock';
exports.default = IconSynchronizeArrowClock;